export default __webpack_public_path__ + "static/media/SI-PY-QAS_Politica Qualità Ambiente Sicurezza FCSI_Rev. 06 del 07-10-2026.a86454ea.pdf";